import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { isOnSale, salePercentOff, saleCountdown } from "../lib/sale";

// Global banner that appears above the navbar whenever any product is on sale.
// Auto-hides when nothing is discounted. Animates a marquee of the deals.
const SaleBanner = () => {
  const [salesOn, setSalesOn] = useState([]);
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    let cancelled = false;
    const load = () =>
      api
        .get("/products")
        .then((r) => {
          if (cancelled) return;
          setSalesOn(r.data.filter(isOnSale));
        })
        .catch(() => {});
    load();
    const id = setInterval(load, 60_000); // refresh every minute
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  useEffect(() => {
    if (!salesOn.some((p) => p.sale_ends_at)) return;
    const id = setInterval(() => setNowMs(Date.now()), 1000);
    return () => clearInterval(id);
  }, [salesOn]);

  if (salesOn.length === 0) return null;

  const messages = salesOn.map((p) => {
    const pct = salePercentOff(p);
    const cd = saleCountdown(p, nowMs);
    const parts = [`${p.name.toUpperCase()}`];
    if (pct > 0) parts.push(`${pct}% OFF`);
    if (cd) parts.push(`ENDS IN ${cd}`);
    return { slug: p.slug, text: parts.join(" // ") };
  });

  // Duplicate messages so the marquee loops seamlessly
  const marquee = [...messages, ...messages];

  return (
    <div
      className="bg-red-600 text-zinc-50 border-b-2 border-red-800 overflow-hidden"
      data-testid="global-sale-banner"
    >
      <div className="relative flex whitespace-nowrap py-2">
        <div className="flex items-center gap-8 animate-[marquee_28s_linear_infinite] pr-8 pl-4 font-mono-tech text-xs uppercase tracking-widest">
          {marquee.map((m, i) => (
            <Link
              to={`/shop/${m.slug}`}
              key={`${m.slug}-${i}`}
              className="flex items-center gap-3 hover:underline"
              data-testid={`sale-marquee-item-${m.slug}`}
            >
              <span className="inline-block w-2 h-2 bg-zinc-50" />
              {m.text}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SaleBanner;
